import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import MainApp from './MainApp'
import HaFaq from './components/HaApp/HaFaq'
import HaInfo from './components/HaApp/HaInfo'
import HaPrivacy from './components/HaApp/HaPrivacy'
import AdminApp from './components/AdminApp'

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/ha-faq" element={<HaFaq />} />
        <Route path="/ha-info" element={<HaInfo />} />
        <Route path="/ha-privacy" element={<HaPrivacy />} />
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/*" element={<MainApp />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
